import React, { useState } from 'react';
import LogoImg from '../../assets/images/MMXLogo_150x150.png'
import BannerBG from '../../assets/images/Loans_WebBanner.png'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import '../../css/button.css';

import { Table, TableBody, TableCell, TableContainer, TableRow, Grid, Chip, Button, Paper } from '@material-ui/core';
import _ from 'lodash';
import { Capitalize } from 'utils/utils'
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
      
    },
    table: {
        minWidth: 650,
    },
    content: {
        backgroundImage: `url(${ LogoImg })`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: 60,
        height: 60,
        margin: 'auto',
        marginTop: 20
    },
    contentHeader: {
        color: '#1a517a', 
        fontWeight: 600, 
        textAlign: 'center',
        // fontFamily: theme.typography.fontFamily,
        padding: 20,
        fontSize: 18
    },
    footer: {
        backgroundImage: `url(${ BannerBG })`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '85%',
        height: 106,
        margin: 'auto',
        marginTop: 20
    }
}));

const stateFields = [
    'person_name',
    'person_emails',
    'person_phones',
    'car_brand',
    'car_model',
    'car_year',
    'car_trim',
    'vehicle_type',
    'body_type',
    'bank',
    'aon',
    'bipd',
    'pa',
    'effective_date',
    'fmv'
]

const getRowLabel = (label) => {
    if(label === 'pa') {
        label = 'Persnal Accident';
    }
    if(label === 'bipd') {
        label = 'Bodily Injury | Property Damage';
    }
    if(label === 'aon') {
        label = 'Acts of Nature';
    }
    if(label === 'fmv') {
        label = 'Fair Market Value';
    }
    if(label === 'person_name') {
        label = 'Customer Name';
    }
    if(label === 'person_phones') {
        label = 'Contact Number';
    }
    if(label === 'person_emails') {
        label = 'Email';
    }
    return label;
}

function SaveDataContent(props) {
    const classes = useStyles();
    const states = useSelector(state => {
        return state.globalStates
    })

    const mapChips = (labels, color = 'primary') => {
        const result = labels ? labels.map((label, index) => {
            return <Chip label={ `${  label }` } color={ color } size="small" style={{ marginRight: 3, marginBottom: 3 }}/> 
        }) : null;
        return result;
    }

    const mapDataFields = () => {
        const content = stateFields.map((field, index) => {
            let dataFieldValue = states[field];
            const label = getRowLabel(field);

            if(dataFieldValue) {
                if( field === 'vehicle_type' || field === 'bank' || field === 'aon'  ) {
                    dataFieldValue = states[field].label
                }
                if(field === 'bipd' || field === 'pa' || field === 'fmv' ) {
                    dataFieldValue = `P ${ states[field].toLocaleString() }`
                }
                if(field === 'effective_date') {
                    dataFieldValue = moment(states[field]).format('MM/DD/YYYY');
                }
                if( field === 'person_emails' || field === 'person_phones' ) {
                    dataFieldValue = mapChips( states[field], 'default' )
                }
            }
            return(
                <TableRow key={ `save-data-key-${ index }` }>
                    <TableCell align={ `left` } style={{ fontWeight: 700 }}>{ `${ Capitalize(label.replace(/\_/g, ' ')) }:` }</TableCell>
                    <TableCell align="left">{ dataFieldValue }</TableCell>
                </TableRow>
            )
        })
        return content;
    }

    return(
        <div>
            <div className={ classes.content }/>
            <div className={ classes.contentHeader }>Save Field values to CRM?</div>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table" size="small">
                    <TableBody>
                    { mapDataFields() }
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid 
                container 
                spacing={2} 
                style={{ textAlign: 'center', paddingTop: 30 }} 
                justify="center"
                className={ classes.footer } 
            >
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={ `btn-success` }
                        onClick={ props.handleSubmit }
                    >
                        Submit
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={ `btn-primary` }
                        onClick={ props.handleModalClose }
                    >
                        Cancel
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
}

export default SaveDataContent;